/* eslint-disable import/no-cycle */
import i18n from '../../../../../i18n/i18n';
import {CockpitWidgetConfig} from './cockpitWidgetConfig';
import WidgetSettingFormField from '../../../../shared/widgets/WidgetSettingFormField';
import {ValidationRules} from '../../../../../utils/validationRules';

export class InterruptionAnalysisWidgetConfig extends CockpitWidgetConfig {
  static onLoadConfig = (rootStore) => rootStore.interruptionReasonSourceStore.loadAll();

  static widgetType = {
    identifier: 'interruption-analysis',
    name: i18n.t('cockpitWidget.widgetTypeIdentifier.interruptionAnalysis'),
  };

  get tabs() {
    return [
      this.generalSettingsTab,
      this.workplaceTab,
      {
        key: 'interruptionAnalysis',
        label: i18n.t('widget.WidgetSettingsModal.interruptionAnalysisConfigTabTitle'),
      },
    ];
  }

  workplace = [
    {
      id: 'hierarchyId',
      label: i18n.t('cockpitWidget.settings.workplace.label'),
      helpText: i18n.t('cockpitWidget.settings.workplace.help'),
      type: WidgetSettingFormField.fieldTypes.HierarchyTreeWorkplace,
    },
  ];

  interruptionAnalysis = [
    {
      id: 'daysBack',
      label: i18n.t('interruptionAnalysisWidgetConfig.settings.interruptionAnalysis.daysBack.label'),
      helpText: i18n.t('interruptionAnalysisWidgetConfig.settings.interruptionAnalysis.daysBack.helpText'),
      type: WidgetSettingFormField.fieldTypes.Number,
      unit: i18n.t('interruptionAnalysisWidgetConfig.settings.interruptionAnalysis.daysBack.unit'),
      defaultValue: 3,
      validations: [ValidationRules.minNumber(1), ValidationRules.maxNumber(7)],
    },
    {
      id: 'interruptionReasonSources',
      label: i18n.t('interruptionAnalysisWidgetConfig.settings.interruptionAnalysis.interruptionReasonSources.label'),
      type: WidgetSettingFormField.fieldTypes.SelectMultiple,
      defaultValue: [],
      options: this.rootStore.interruptionReasonSourceStore.sources.map((irs) => ({
        value: irs.id,
        label: irs.name,
      })),
      validations: [ValidationRules.required],
    },
  ];
}
